import { DOCUMENT, isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AssetVersionPageComponent } from 'src/app/gallery-shared/pages/asset-version-page/asset-version-page.component';
import { enableBodyScroll } from 'src/app/lib/toggle-body-scroll';
import { AssetService } from 'src/app/services/asset.service';
import { BrowserService } from 'src/app/services/browser.service';
import { RedirectService } from 'src/app/services/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class AssetVersionDeactivateGuard {
  constructor(
    private assetService: AssetService,
    private browserService: BrowserService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private redirectService: RedirectService
  ) {}

  canDeactivate(
    component: AssetVersionPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): boolean {
    if (isPlatformServer(this.platformId)) return true;
    if (this.browserService.urlIsAssetUrl(nextState.url)) {
      // Going to another asset
      // this.document.body.classList.add('noscroll-asset');
      return true;
    }
    enableBodyScroll('asset');
    return true;
  }
}
